import { render } from "./Comments.vue?vue&type=template&id=30e29ddc&scoped=true&ts=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=30e29ddc&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30e29ddc"]])

export default __exports__